import { Controller } from "@hotwired/stimulus"

// Expands an accounts-grid row to reveal its team list. The detail row is
// the next sibling <tr> (table rows can't nest), rendered server-side with
// the page, so toggling costs no request.
export default class extends Controller {
  static targets = ["chevron"]

  toggle(event) {
    event.preventDefault()

    const detail = this.detailRow()
    if (!detail) return

    const expanded = detail.classList.toggle("d-none") === false
    this.setChevron(expanded)
  }

  detailRow() {
    const next = this.element.nextElementSibling
    return next?.classList.contains("dm-detail-row") ? next : null
  }

  setChevron(expanded) {
    if (!this.hasChevronTarget) return

    // FontAwesome's SVG-with-JS mode replaces the <i> with an <svg>, keeping
    // the fa-* classes, so match either element.
    const icon = this.chevronTarget.querySelector("i, svg")
    icon?.classList.toggle("fa-caret-right", !expanded)
    icon?.classList.toggle("fa-caret-down", expanded)
    this.chevronTarget.setAttribute("aria-label", expanded ? "Hide team" : "Show team")
  }
}
